import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Container, type CuiTheme, Row } from '@crehana/ui';
import { getImgxUrl } from '@crehana/utils';

import type { CampaignProps } from '@/views/Campaign/types';

import { LeftContainer, Wrapper } from './Hero.styles';

const IMAGE_SRC =
  'https://crehana-public-catalog.imgix.net/images/app/gallery/2021/11/09/87e8dfdf/d73a6fb9.png';

const Hero: React.FC<
  React.PropsWithChildren<CampaignProps['hero'] & { h1?: string }>
> = ({
  imageDesktop,
  imageMobile,
  imageTablet,
  h1,
  description,
  logoMobile,
  logoDesktop,
}) => {
  return (
    <Wrapper className="sm:pb-64 relative overflow-hidden">
      <Container className="sm:pt-64 md:pt-96 lg:relative">
        <Row className="relative">
          <Col xs={12} md={6} className="flex">
            <LeftContainer className="text-center md:text-left relative z-2 mr-auto ml-auto my-auto">
              {logoMobile && (
                <div
                  className="md:hidden mb-24 mt-96 md:mt-56 relative m-auto"
                  css={`
                    width: 250px;
                    height: 70px;
                    ${({ theme }: { theme: CuiTheme }) =>
                      theme.breakpoints.up('sm')} {
                      width: 360px;
                      height: 100px;
                    }
                    ${({ theme }: { theme: CuiTheme }) =>
                      theme.breakpoints.up('lg')} {
                      width: 260px;
                      height: 100px;
                    }
                  `}
                >
                  <Image
                    objectFit="contain"
                    objectPosition="center"
                    alt="Campaign logo"
                    layout="fill"
                    priority
                    src={logoMobile}
                  />
                </div>
              )}
              {logoDesktop && (
                <div
                  className="hidden md:block relative mr-auto"
                  css={`
                    width: 280px;
                    height: 120px;
                  `}
                >
                  <Image
                    alt="Campaign logo"
                    layout="fill"
                    objectFit="contain"
                    objectPosition="center"
                    priority
                    src={logoDesktop}
                  />
                </div>
              )}
              <h1 className="font-h1 text-white my-32">{h1}</h1>
              <p className="font-body1 mb-16 sm:mb-24 md:mb-40 text-white">
                {description}
              </p>
            </LeftContainer>
          </Col>
          <Col md={6}>
            <div
              className="hidden lg:block relative w-full m-auto"
              css={`
                height: 290px;
                ${({ theme }: { theme: CuiTheme }) =>
                  theme.breakpoints.up('lg')} {
                  height: 540px;
                  width: 520px;
                }
              `}
            >
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <Image
                src={imageDesktop || IMAGE_SRC}
                layout="fill"
                objectFit="contain"
                placeholder="blur"
                blurDataURL={getImgxUrl(imageMobile || IMAGE_SRC, {
                  w: 20,
                  px: 2,
                })}
              />
            </div>
            <div
              className="hidden sm:block lg:hidden relative w-full m-auto"
              css={`
                height: 290px;
                ${({ theme }: { theme: CuiTheme }) =>
                  theme.breakpoints.up('sm')} {
                  height: 520px;
                  width: 500px;
                }
              `}
            >
              {/* This syntax requires an imported helper but module 'tslib' cannot be found. */}
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <Image
                src={imageTablet || IMAGE_SRC}
                layout="fill"
                objectFit="contain"
                placeholder="blur"
                blurDataURL={getImgxUrl(imageMobile || IMAGE_SRC, {
                  w: 20,
                  px: 2,
                })}
              />
            </div>
            <div
              className="sm:hidden relative w-full m-auto"
              css={`
                height: 290px;
              `}
            >
              {/* This syntax requires an imported helper but module 'tslib' cannot be found. */}
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <Image
                src={imageMobile || IMAGE_SRC}
                layout="fill"
                objectFit="contain"
                placeholder="blur"
                blurDataURL={getImgxUrl(imageMobile || IMAGE_SRC, {
                  w: 20,
                  px: 2,
                })}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default Hero;
